import Paginator from './paginator.js';
import { isApp, isContentItem, isContentVersion } from './utils.js';
var ContentItemApi = /** @class */ (function () {
    function ContentItemApi(executor, name, appOrToken) {
        var _this = this;
        this.executor = executor;
        this.name = name;
        this.appOrToken = appOrToken;
        this.pagination = function () { return new Paginator(_this.executor); };
        this.list = function (nextPage) {
            return _this.executor.execute(nextPage || _this.baseUrl);
        };
        this.get = function (form) {
            var url = "" + _this.baseUrl + form + "/";
            return _this.executor.execute(url);
        };
        this.create = function (data) {
            return _this.executor.execute(_this.baseUrl, {
                method: 'POST',
                headers: _this.executor.headers(),
                body: JSON.stringify(data),
            });
        };
        this.edit = function (item, data) {
            var url = _this.contentItemUrl(item);
            return _this.executor.execute(url, {
                method: 'PUT',
                headers: _this.executor.headers(),
                body: JSON.stringify(data),
            });
        };
        this.delete = function (item) {
            var url = _this.contentItemUrl(item);
            return _this.executor.execute(url, {
                method: 'DELETE',
                headers: _this.executor.headers(),
            });
        };
        this.makeAvailable = function (item) {
            var url = _this.contentItemUrl(item) + "make_available/";
            return _this.executor.execute(url, { headers: _this.executor.headers(), method: 'POST' });
        };
        this.makeUnavailable = function (item) {
            var url = _this.contentItemUrl(item) + "make_unavailable/";
            return _this.executor.execute(url, { headers: _this.executor.headers(), method: 'POST' });
        };
        this.listVersions = function (item, nextPage) {
            var url = nextPage || _this.contentItemUrl(item) + "versions/";
            return _this.executor.execute(url);
        };
        this.getVersion = function (item, number) {
            var url = _this.contentVersionUrl(number, item);
            return _this.executor.execute(url);
        };
        this.createVersion = function (item, data) {
            var url = _this.contentItemUrl(item) + "versions/";
            return _this.executor.execute(url, {
                method: 'POST',
                headers: _this.executor.headers(),
                body: JSON.stringify(data),
            });
        };
        this.editVersion = function (version, data, item) {
            var url = _this.contentVersionUrl(version, item);
            return _this.executor.execute(url, {
                method: 'PUT',
                headers: _this.executor.headers(),
                body: JSON.stringify(data),
            });
        };
        this.packageVersion = function (version, item) {
            var url = _this.contentVersionUrl(version, item) + "package/";
            return _this.executor.execute(url, { method: 'POST', headers: _this.executor.headers() });
        };
        this.listPublishingRecords = function (item, nextPage) {
            var url = nextPage || _this.contentItemUrl(item) + "publishing_records/";
            return _this.executor.execute(url);
        };
        this.contentItemUrl = function (ci) {
            if (isContentItem(ci)) {
                return ci.url;
            }
            else {
                return "" + _this.baseUrl + ci + "/";
            }
        };
        this.contentVersionUrl = function (version, item) {
            if (isContentVersion(version)) {
                return version.url;
            }
            else if (isContentItem(item)) {
                return item.url + "versions/" + version + "/";
            }
            else {
                return "" + _this.baseUrl + item + "/versions/" + version + "/";
            }
        };
        if (this.appOrToken === undefined) {
            throw Error('App is undefined! Please specify the app you are accessing!');
        }
    }
    Object.defineProperty(ContentItemApi.prototype, "baseUrl", {
        get: function () {
            return isApp(this.appOrToken)
                ? this.appOrToken[this.name]
                : this.executor.url("api/v2/apps/" + this.appOrToken + "/" + this.name + "/");
        },
        enumerable: true,
        configurable: true
    });
    return ContentItemApi;
}());
export default ContentItemApi;
//# sourceMappingURL=content-item-api.js.map